<div *ngIf="(whoisOnlineService.liveAppUuid$ | async) as info">

  <button (click)="updateApp(info.liveUuid)" *ngIf="info.hasNewVersion" class="mat-primary" mat-raised-button>
    {{'Mise à jour'|translate}}
  </button>

</div>
